import { render, staticRenderFns } from "./IconInspirator.vue?vue&type=template&id=185141e4"
import script from "./IconInspirator.vue?vue&type=script&lang=js"
export * from "./IconInspirator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports